export function getEstimatedSavingsPercent(trimSummary) {
  const savingsPercent = Math.round((trimSummary?.pricing?.estimatedSavings / trimSummary?.pricing?.totalMsrp) * 100);
  const savingsPercentValue = `${Intl.NumberFormat('en-US', { signDisplay: 'exceptZero' }).format(savingsPercent * -1)}%`;
  return Number.isFinite(savingsPercent) ? savingsPercentValue : undefined;
}
